import { assetTickBlack } from "~/assets/assets";
import { useDenominationGridContext } from "../context/denomination_grid_context";

export function CustomAmountInput() {
  const {
    customAmountInputDebounce,
    defaultAmountInCustomInput,
    internalState,
  } = useDenominationGridContext();

  const { dryRunErrorMessage } = internalState;
  const isInvalid = () => dryRunErrorMessage() != null;

  return (
    <div
      class="relative flex max-h-12 w-full items-center justify-start rounded-lg border-2 border-neutral-700 px-4 py-2 darkTheme:border-basePrimaryDark  darkTheme:bg-baseTertiaryDark dark:border-baseTertiaryLight lg:py-3.5"
      classList={{
        "border-red-700": isInvalid(),
      }}
    >
      <div class="text-base inline-flex w-full  text-[15px] font-semibold text-neutral-700 darkTheme:text-basePrimaryDark dark:text-baseTertiaryLight">
        <span class="ml-1 text-[15px]">₹</span>
        <input
          id="custom-amount-input"
          placeholder="Enter amount"
          type="number"
          class="grow-1 ml-1 border-0 bg-transparent text-f16  placeholder-gray-400 placeholder:text-f16 focus:border-transparent focus:outline-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
          value={defaultAmountInCustomInput ?? undefined}
          onInput={(event) => {
            customAmountInputDebounce(parseInt(event.target.value!));
          }}
        />
      </div>
      <div class="absolute right-[6px] top-[6px] block h-[6px] w-[9px]">
        <img src={assetTickBlack} width={9} height={6} alt="tick" />
      </div>
    </div>
  );
}
